module.exports = __webpack_public_path__ + "static/img/smartAutomatedPhone.519b0fd9.png";